import React from 'react';
import { Link } from 'react-router-dom';
import { MenuItems } from './MenuItems';
import './Dropdown.css';

function Dropdown({ onLinkClick = () => undefined }) {
  return (
    <ul className="dropdown-menu">
      {MenuItems.map((item) => (
        <li key={item.id}>
          {/* 1. subMenu */}
          {item.subMenu1 && (
            <>
              <span className="dropdown-submenu">
                <Link to="/vuokrattavat" onClick={onLinkClick}>
                  {item.title}
                </Link>
              </span>
              <ul className="submenu">
                {item.subMenu1.map((subItem) => (
                  <li key={subItem.id}>
                    <Link
                      className={subItem.cName}
                      to={subItem.slug ? `/tuote/${subItem.slug}` : subItem.path}
                      onClick={onLinkClick}
                    >
                      {subItem.title}
                      {subItem.isNew && (
                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                          Uusi
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}

          {/* 2. subMenu */}
          {item.subMenu2 && (
            <>
              <span className="dropdown-submenu">
                <Link to="/vuokrattavat" onClick={onLinkClick}>
                  {item.title}
                </Link>
              </span>
              <ul className="submenu">
                {item.subMenu2.map((subItem) => (
                  <li key={subItem.id}>
                    <Link
                      className={subItem.cName}
                      to={subItem.slug ? `/tuote/${subItem.slug}` : subItem.path}
                      onClick={onLinkClick}
                    >
                      {subItem.title}
                      {subItem.isNew && (
                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                          Uusi
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}

          {/* 3. subMenu */}
          {item.subMenu3 && (
            <>
              <span className="dropdown-submenu">
                <Link to="/vuokrattavat" onClick={onLinkClick}>
                  {item.title}
                </Link>
              </span>
              <ul className="submenu">
                {item.subMenu3.map((subItem) => (
                  <li key={subItem.id}>
                    <Link
                      className={subItem.cName}
                      to={subItem.slug ? `/tuote/${subItem.slug}` : subItem.path}
                      onClick={onLinkClick}
                    >
                      {subItem.title}
                      {subItem.isNew && (
                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                          Uusi
                        </span>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          )}
        </li>
      ))}
    </ul>
  );
}

import PropTypes from "prop-types";

Dropdown.propTypes = {
  onLinkClick: PropTypes.func, // nyt ESLint on tyytyväinen
};


export default Dropdown;
